import React from 'react';
import { connect } from 'react-redux';
import EnumSelectorBase from './EnumSelectorBase';

const PointTypeSelector = ({ pointTypes, value, setValue, sortOptions, renderOption }) => (
  <EnumSelectorBase
    name="Point Type"
    options={Object.values(pointTypes).sort(sortOptions)}
    getOptionLabel={(type) => type?.name || ''}
    isOptionEqualToValue={(option, v) => option.id === v.id}
    value={value}
    onChange={setValue}
    renderOption={renderOption}
  />
);

export default connect(
  ({
    entities: {
      pointTypes: { byId: pointTypes },
    },
  }) => ({
    pointTypes,
  })
)(PointTypeSelector);
